import {languageProcessing} from '@axyseo/index.js';
const {createRegexFromArray, getClauses} = languageProcessing;

import PortugueseClause from '../values/Clause';
import auxiliaries from '../config/internal/passiveVoiceAuxiliaries.js';
import stopwords from '../config/stopWords.js';
const followingAuxiliaryExceptionWords = ['o', 'a', 'os', 'as', 'um', 'ums', 'uma', 'umas'];

const options = {
  Clause: PortugueseClause,
  stopwords: stopwords,
  auxiliaries: auxiliaries,
  regexes: {
    auxiliaryRegex: createRegexFromArray(auxiliaries),
    stopCharacterRegex: /([:,])(?=[ \n\r\t'"+\-»«‹›<>])/gi,
    followingAuxiliaryExceptionRegex: createRegexFromArray(followingAuxiliaryExceptionWords)
  }
};

/**
 * Gets the clauses from a sentence by determining sentence breakers.
 *
 * @param {string} sentence The sentence to split up into clauses.
 *
 * @returns {Array} The array with all clauses that have an auxiliary.
 */
export default function getPortugueseClauses(sentence) {
  return getClauses(sentence, options);
}
